import "@babel/polyfill";

import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import i18n from "./locales";
import "@/core/use";
import "@/core/permission";
import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";
import VueDragResize from "vue-drag-resize";

import { GetQueryString } from "@/utils/utils";
import { referer, hideHeaderOrLeftMenu } from "@/utils/referer";
import pageConfig from "@/options/pageConfig";

import * as filters from "@/filters/filters";
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

// 阿里图标下载至本地（CDN方式暂不可用，后续可用时可去除）
import "@/assets/font/iconfont.css";

Vue.use(preview);
Vue.component("vue-drag-resize", VueDragResize);

// 全局变量
let app_id = pageConfig.appId;
Vue.prototype.$app_id = app_id;
Vue.prototype.$jsutil = jsutil;
Vue.config.productionTip = false;

const app_run = () => {
  new Vue({
    el: "#app",
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount("#app");
};

async function initProject() {
  // referer登录
  let loginType = GetQueryString("loginType");
  if (loginType === "referer") {
    await referer(store, router, app_id);
  }

  // 设置地图主题
  const mapTheme = localStorage.getItem("AmapTheme");
  if (mapTheme) {
    store.commit("setMapTheme", mapTheme);
  }

  store.commit("updateLang", GetQueryString("lang") == "en" ? "en" : "zh");
  // 头部及侧边栏的显示隐藏
  hideHeaderOrLeftMenu(store);
  app_run();
}

initProject();
